import React from "react";
import "./components/traningModule/traningStyle.css";

function Slides() {
  return (
    <div>
      <div class="slfryrightpdfmain fryslide2 vatSlidemain_wrpr">
        <div class="slmaincontainer vatSlidemain_subwrpr">
          <div class="slbannertitle vatSlide_title">
            <h2>What is Vat Cleaning Protocol?</h2>
          </div>

          <div class="slfryleftleftwrp vatSlide_text">
            <p>
            The Vat Cleaning Protocol is the process of dumping the old oil, cleaning the fryer vats of carbon residue and putting in new oil. It is the most important protocol in the fry right system. It is 
performed at the end and beginning of every Quality CycleTM  using a powerful non-toxic detergent provided through the fry right system. The vat cleaning protocol is accomplished through the closing crew and the opening crew working together. This could be a designated Maintenance Person, Closing Cook, Opening Cook, Shift Lead, Manager or any combination. It consists of 
two (2) steps, Vat Prep performed at closing and Vat 
Scrub performed pre-opening.
            </p>

           
          </div>
        </div>
      </div>
    </div>
  );
}

export default Slides;
